import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthContext } from "../../context/auth";
import { RootState } from "../../state/reducer";
import { mapDispatchToProps as issuesDispatch } from "../../state/reducer/app-store-issues";
import AppStoreIssueBannerView from "./index.view";

const BANNER_ELIGIBLE_ROLES = new Set([
    "Admin",
    "Organization Admin",
    "Manager",
    "Budtender",
]);

const AppStoreIssueBanner: React.FC = () => {
    const { authState } = useContext(AuthContext);
    const [activeIssueId, setActiveIssueId] = useState<number | null>(null);

    const { issues } = useSelector(
        (state: RootState) => state.appStoreIssues.getActiveIssues
    );

    // Derive the open issue from the live list by id rather than caching its
    // attributes. When polling resolves this issue it drops off `issues`, so
    // the lookup yields null and the modal closes automatically — even while
    // other issues remain on the banner.
    const activeIssue =
        issues.find((res) => res.id === activeIssueId)?.attributes ?? null;
    const { startActiveIssuesPolling, stopActiveIssuesPolling } =
        issuesDispatch();

    const userType = authState?.user?.attributes?.type;
    const roleName =
        authState?.user?.relationships?.role?.attributes?.name ?? "";
    const isClientPortalUser =
        userType === "user" && BANNER_ELIGIBLE_ROLES.has(roleName);

    useEffect(() => {
        if (!authState?.loading && isClientPortalUser) {
            startActiveIssuesPolling();
            return () => {
                stopActiveIssuesPolling();
            };
        }
        return undefined;
    }, [authState?.loading, isClientPortalUser]);

    return (
        <AppStoreIssueBannerView
            visible={isClientPortalUser}
            issues={issues}
            activeIssue={activeIssue}
            onOpenIssue={(issueId) => setActiveIssueId(issueId)}
            onCloseIssue={() => setActiveIssueId(null)}
        />
    );
};

export default AppStoreIssueBanner;
